import { useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import React from 'react';
import clsx from 'clsx';
import styles from './explore-picker.module.scss';
import { testIds } from '@smart-tv/e2e/shared/variables';
import Typography from '../typography/typography';

import ExploreKidsIcon from '../icons/explore/kids';
import ExploreShowsIcon from '../icons/explore/shows';
import ExploreSeriesIcon from '../icons/explore/series';
import ExploreDocumentariesIcon from '../icons/explore/documentaries';
import ExploreMoviesIcon from '../icons/explore/movies';

type Props = {
  handleClick?: () => void;
  focusKey: string;
  title: string;
};

const ExploreButton = (props: Props) => {
  const { handleClick, focusKey, title } = props;

  const { ref, focused } = useFocusable({
    onEnterPress: handleClick,
    focusKey: focusKey
  });

  const renderIcon = () => {
    switch (title) {
      case 'Børn':
        return <ExploreKidsIcon viewBox='0 0 160 160' className={styles['explore-picker__button-icon']} />;
      case 'Udsendelser':
        return <ExploreShowsIcon viewBox='0 0 160 160' className={styles['explore-picker__button-icon']} />;
      case 'Serier':
        return <ExploreSeriesIcon viewBox='0 0 160 160' className={styles['explore-picker__button-icon']} />;
      case 'Dokumentarer':
        return <ExploreDocumentariesIcon viewBox='0 0 160 160' className={styles['explore-picker__button-icon']} />;
      case 'Film':
        return <ExploreMoviesIcon viewBox='0 0 160 160' className={styles['explore-picker__button-icon']} />;
      default:
        return null;
    }
  };

  return (
    <div className={styles['explore-picker__button-container']}>
      <button
        type="button"
        aria-label={title}
        data-testid={testIds.explorePicker.buttons.exploreButton}
        className={clsx(styles['explore-picker__button'], focused && styles['explore-picker__button--focused'])}
        ref={ref}
        onClick={handleClick}
      >
        <div className={styles['explore-picker__button-content']}>
          {renderIcon()}
        </div>
      </button>
      <Typography variant="bodySmall" className={styles['explore-picker__button-title']}>
        {title}
      </Typography>
    </div>
  );
};

export default ExploreButton;
